import Call from '../../Call.v2';
import { objToQs } from '../../Utils';

const apkInstallationsHourly = {
    get(filters) {
        return Call(`peerclick/apkInstallationsHourly?${objToQs(filters)}`);
    },
    getSubid(filters) {
        return Call(`peerclick/apkInstallationsHourly/subid?${objToQs(filters)}`);
    }
};

export default apkInstallationsHourly;



// WEBPACK FOOTER //
// ./src/services/API/components/peerclick/apkInstallationsHourly.js